import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const CATALOG_CONSTANTS = {
  id: 'admin.system.catalog',
  title: 'Administración de Catálogos',

  labels: {
    ...COMMONS,
    saveSuccess: 'El catálogo se guardó exitosamente!',
  },

  actions: {
    ...ACTIONS,
    edit: `${ACTIONS.edit} Catálogo`,
  },
};
